{
  "Core": "Core",
  "Elite": "Elite",
  "Essentials": "Essentials",
  "Plus": "Plus",
  "Pro": "Pro",
  "Ultimate": "Ultimate",
  "ultimate-bundle": {
    "1:1 Training sessions are included in the Ultimate Bundle. Get the most out of Weave by scheduling now!": "1:1 Training sessions are included in the Ultimate Bundle. Get the most out of Weave by scheduling now!",
    "Schedule 1:1 Training": "Schedule 1:1 Training"
  }
}
